<script lang="ts" setup>
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { init, appInited } from './app'
onMounted(init)

</script>

<template>
  <AppProvider>
    <ElConfigProvider :locale="zhCn" namespace="sp">
      <RouterView v-if="appInited" />
    </ElConfigProvider>
  </AppProvider>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
